export default __webpack_public_path__ + "static/media/output_movie.9d764728.mov";